/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer";
import Header from "../Header";

const ErrorPage = () => {
  return (
    <>
      <Header />
      <div className="  bg-[url('../images/all-img/404-bg.png')] bg-cover bg-no-repeat bg-center">
        <div className="max-w-[570px] mx-auto flex flex-col items-center text-center justify-center min-h-screen px-4">
          <h2 className=" mb-6">Page non trouvée</h2>
          <div className="mb-10">
              La page que vous demandez n'a pas été trouvée.
          </div>
          <Link to={"/"} className="btn btn-primary">
            Retour
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ErrorPage;
